import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ErrorService } from '../../services/error.service';
import { AdminRegexClassifierService } from '../../services/admin/admin-regexclassifier.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, EmailType, Language } from '../../global/constants';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-unsub-classifier',
  templateUrl: './admin-unsub-classifier.component.html'
})
export class AdminUnsubClassifierComponent implements OnInit {
  loadingPage = true;
  editTrainingDialogRef: BsModalRef;
  currentLanguage: Language;
  training: any[] = [];

  currentTraining: any = {
    training: [],
    lang: 'en'
  };

  languageFilter: string = 'en';

  constructor(private errorService: ErrorService,
              private modalService: BsModalService,
              private adminRegexClassifierService: AdminRegexClassifierService,
              private globalMessageService: GlobalMessageService,
              private constants: Constants) { }

  ngOnInit() {
    this.currentLanguage = this.constants.languages[0];
    this.refreshTraining();
  }

  changeLanguage() {
    this.currentLanguage = this.constants.languages.find((l:Language) => {
      return l.name == this.languageFilter;
    });
    this.refreshTraining();
  }

  editTraining(dialog, training: any = null) {
    this.currentTraining.training = training ? training.terms : [];
    this.currentTraining.lang = training ? training.language : this.languageFilter;
    this.editTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-lg'});
  }

  saveTraining() {
    this.editTrainingDialogRef.hide();
    if (this.currentTraining._id) {
      this.adminRegexClassifierService.updateRegexTraining(this.currentTraining._id, 'unsubscribe', this.currentTraining.lang, this.currentTraining.training).subscribe(
        (result: any) => {
          this.globalMessageService.message('Updated training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-regex-classifier.component', 'editTraining.100');
        }
      )
    }
    else {
      this.adminRegexClassifierService.newRegexTraining('unsubscribe', this.currentTraining.lang, this.currentTraining.training).subscribe(
        (result: any) => {
          this.globalMessageService.message('Added training');
          this.refreshTraining();
        },
        error => {
          this.globalMessageService.error();
          this.errorService.log(error, 'admin-regex-classifier.component', 'editTraining.200');
        }
      )
    }
  }

  delete(training: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this training: "${training.terms}"`,
        confirm: function() {
          me.adminRegexClassifierService.deleteRegexTraining(training._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Training was deleted');
              me.refreshTraining();
            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'admin-regex-classifier.component', 'delete');
            });
        }
      }
    }));
  }

  private refreshTraining() {
    this.loadingPage = true;
    this.adminRegexClassifierService.getRegexTraining('unsubscribe', this.currentLanguage.name)
    .subscribe(
      (result: any) => {
        this.training = result;
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'admin-unsub-classifier.component', 'refreshTraining.100');
      }
    )
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-unsub-classifier/admin-unsub-classifier.component.ts